module.exports = __webpack_public_path__ + "img/1400m.9ca1e8a1.png";